import axios from "axios";
import { ADF_ENDPOINTS } from "./adfEndpoints";

export interface TableData {
  sourceProfile: string;
  targetProfile: string;
  targetRegion: string;
  process: string;
  status: string;
  MA_Dataload_ts_UTC: string;
  user: string;
}

export const fetchHistory = async (
  interfaceName: string
): Promise<TableData[]> => {
  const response = await axios.get<TableData[]>(
    `${ADF_ENDPOINTS.LOG_HISTORY}?interfaceName=${encodeURIComponent(
      interfaceName
    )}`,
    {
      withCredentials: true,
    }
  );
  return response.data;
};
